var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"personal-profile"},[_c('router-link',{attrs:{"to":"/profile"}},[_vm._v("← back")]),_c('div',[_vm._v(_vm._s(_vm.person.name))]),_c('div',[_vm._v(_vm._s(_vm.person.birthday))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }